import {
	POST_NEW_INCIDENCES,
	POST_NEW_INCIDENCES_ERROR,
	POST_NEW_INCIDENCES_ERROR_SHOW,
	POST_NEW_INCIDENCES_SUCCESS,
} from './../../constants';

export const postNewIncidencesReducer = (state, actions) => {
	switch (actions.type) {
		case POST_NEW_INCIDENCES:
			return {
				...state,
				loading: true,
			};
		case POST_NEW_INCIDENCES_ERROR:
			return {
				incidences: state.incidences,
				//	collaboratorsOptions: state.collaboratorsOptions,
				loading: false,
				error: actions.payload,
				errorShow: false,
			};
		case POST_NEW_INCIDENCES_SUCCESS:
			return {
				incidences: actions.payload,
				//collaboratorsOptions: getCollaboratorOptions(actions.payload),
				loading: false,
				error: null,
				errorShow: false,
			};
		case POST_NEW_INCIDENCES_ERROR_SHOW:
			return {
				...state,
				errorShow: true,
			};
		default:
			return state;
	}
};
